import { createFileRoute, redirect } from "@tanstack/react-router";

import { firstSensoryProfileStepId } from "@/lib/routes";

export const Route = createFileRoute("/sensory-profile/")({
  beforeLoad: () => {
    throw redirect({
      to: "/sensory-profile/$stepId",
      params: { stepId: firstSensoryProfileStepId() },
    });
  },
});
